import { useState } from 'react';
import { Link } from 'react-router-dom';
import { bg, line, tx, font, accent, space, radius } from '../theme';
import Button from '../components/Button';
import { useAuth } from '../lib/auth';
import { supabase } from '../lib/supabaseClient';

const label = {
  fontFamily: font.display, fontSize: 11, fontWeight: 700,
  letterSpacing: '0.14em', textTransform: 'uppercase', color: tx.muted,
  marginBottom: space.s2, display: 'block',
};
const input = {
  width: '100%', background: bg.base, color: tx.primary,
  border: `1px solid ${line.DEFAULT}`, borderRadius: radius.md,
  padding: '10px 12px', fontFamily: font.data, fontSize: 14, boxSizing: 'border-box',
};
const Card = ({ title, children }) => (
  <section style={{
    background: bg.surface, border: `1px solid ${line.DEFAULT}`,
    borderRadius: radius.lg, padding: space.s5, marginBottom: space.s4,
  }}>
    <h2 style={{
      fontFamily: font.display, fontSize: 12, fontWeight: 700, letterSpacing: '0.12em',
      textTransform: 'uppercase', color: tx.muted, margin: `0 0 ${space.s4}px`,
    }}>{title}</h2>
    {children}
  </section>
);

export default function Settings() {
  const { user, signOut } = useAuth();
  const meta = user?.user_metadata || {};

  const [firstName, setFirstName] = useState(meta.firstName || '');
  const [lastName, setLastName] = useState(meta.lastName || '');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  async function saveName() {
    setBusy(true); setMsg('');
    const { error } = await supabase.auth.updateUser({
      data: { firstName: firstName.trim(), lastName: lastName.trim() },
    });
    setBusy(false);
    setMsg(error ? (error.message || 'Could not save.') : 'Saved.');
  }

  return (
    <div style={{ maxWidth: 680, margin: '0 auto', padding: space.s6 }}>
      <div style={{ marginBottom: space.s6 }}>
        <div style={{
          fontFamily: font.display, fontSize: 11, fontWeight: 700, letterSpacing: '0.24em',
          textTransform: 'uppercase', color: accent.lime, marginBottom: space.s2,
        }}>
          Your account
        </div>
        <h1 style={{ fontFamily: font.display, fontSize: 30, fontWeight: 700, margin: 0 }}>
          Account settings.
        </h1>
      </div>

      <Card title="Your details">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: space.s4, marginBottom: space.s4 }}>
          <div>
            <span style={label}>First name</span>
            <input style={input} value={firstName} onChange={(e) => setFirstName(e.target.value)} maxLength={40} />
          </div>
          <div>
            <span style={label}>Last name</span>
            <input style={input} value={lastName} onChange={(e) => setLastName(e.target.value)} maxLength={40} />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <span style={label}>Email</span>
            <input style={{ ...input, color: tx.muted, cursor: 'not-allowed' }} value={user?.email || ''} readOnly />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: space.s3 }}>
          <Button onClick={saveName} disabled={busy || (!firstName.trim() || !lastName.trim())}>
            {busy ? 'Saving…' : 'Save changes'}
          </Button>
          {msg && (
            <span style={{ fontFamily: font.data, fontSize: 13, color: msg === 'Saved.' ? accent.green : accent.red }}>
              {msg}
            </span>
          )}
        </div>
      </Card>

      <Card title="Director of Football">
        <p style={{ color: tx.secondary, fontSize: 14, margin: `0 0 ${space.s4}px` }}>
          Your in-game identity &mdash; background, strengths and look &mdash; is managed separately.
        </p>
        <Link to="/hub/profile" style={{ textDecoration: 'none' }}>
          <Button variant="ghost">Edit game profile</Button>
        </Link>
      </Card>

      <Card title="Session">
        <Button variant="danger" onClick={signOut}>Sign out</Button>
      </Card>
    </div>
  );
}
